import React from 'react'
import { Checkbox } from 'material-ui'
import styles from './styles/ReminderCheckbox'

const ReminderCheckbox = props => {
  const tooltipText = props.sendRegardlessOfFutureAppt
    ? "Always send this message even if a patient has appointments scheduled within the next year"
    : "Always send this message even if a patient has replied 'YES' to a previous reminder message"
  return (
    <div
      className="checkbox-container"
      style={styles.checkboxContainer}
      onMouseEnter={props.toggleTooltip}
      onMouseLeave={props.toggleTooltip}
    >
      <Checkbox
        checked={props.shouldAlwaysSend}
        label="Always Send"
        style={styles.checkbox}
        labelStyle={styles.checkboxLabel}
        onCheck={props.handleCheckboxClick}
      />
      {!props.isTooltipActive ? null :
      <div className="tooltip" style={styles.tooltip}>
        <span>{tooltipText}</span>
      </div>
        }
    </div>
  )
}

export default ReminderCheckbox



// WEBPACK FOOTER //
// ./src/components/Settings/ReminderCheckbox.js